// extracted by mini-css-extract-plugin
export default {"card":"Card_card__Rl06T","imagecontainer":"Card_imagecontainer__BGO+h","image":"Card_image__jRrQB","btn":"Card_btn__PIRfx"};